// src/components/ui/Card.jsx
import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  elevation = 'md',
  ...props 
}) => {
  const baseStyles = 'rounded-lg bg-white overflow-hidden';
  
  const elevations = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
  };
  
  return (
    <div 
      className={`${baseStyles} ${elevations[elevation]} ${className} p-6`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;